<template>
  <div v-if="selectedFiles.length" class="relative flex">
    <div class="flex max-h-28 flex-wrap gap-2 overflow-y-auto p-3">
      <selected-file
        v-for="(file, index) in selectedFiles"
        :key="index"
        :file="file"
        @file:remove="removeFile(index)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";

import { useFiles } from "@/stores/ai/files";

import SelectedFile from "@/components/cmdK/chat/files/SelectedFile.vue";

const aiFilesStore = useFiles();

const { removeFile } = aiFilesStore;
const { selectedFiles } = storeToRefs(aiFilesStore);
</script>
